import React, { useState } from 'react';
import { CheckIcon, PlusIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { copy } from '../../data/copy';
import { quickTaskPresets } from '../../data/neutralTemplate';
import { Button } from '../ui/Button';
import { EmptyNote } from '../ui/Panel';
export function SharedLists() {
  const {
    db,
    family,
    memberById,
    addShopping,
    toggleShopping,
    clearBought
  } = useAppState();
  const [text, setText] = useState('');
  const items = db.shopping.filter(s => s.familyId === family.id);
  const bought = items.filter(i => i.done).length;
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!text.trim()) return;
    addShopping(text.trim());
    setText('');
  };
  return <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_300px]" data-id="element-242" data-mp="b2uu4rpvjz9l">
      <div data-id="element-243" data-mp="1hkrp6p2hhc67">
        <h3 className="font-display text-lg font-semibold" data-id="element-244" data-mp="1hl1j2nqng3h6">Nakupovalni seznam</h3>
        <form onSubmit={submit} className="mt-2 flex gap-2" data-id="element-245" data-mp="1mit7v8vzz9h5">
          <input className="field" aria-label="Nov artikel" value={text} onChange={e => setText(e.target.value)} placeholder="Kaj zmanjkuje? npr. jajca" data-id="element-246" data-mp="1fza5pkyo6q8a" />
          <Button type="submit" disabled={!text.trim()} data-id="element-247" data-mp="1bv2e9g0tuw6d">
            <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-248" data-mp="16x0vkw7bcyvf" /> Dodaj
          </Button>
        </form>
        {items.length === 0 ? <div className="mt-3" data-id="element-249" data-mp="11yr1yq18m6bx">
            <EmptyNote data-id="element-250" data-mp="wzntevm1thz7">{copy.emptyShopping}</EmptyNote>
          </div> : <ul className="mt-3 divide-y divide-line rounded-3xl border-[1.5px] border-line bg-surface" data-id="element-251" data-mp="x1qvie0h71ka">
            {items.map(i => <li key={i.id} className="flex items-center gap-3 px-3 py-2" data-id="element-252" data-mp="o6sz2wy4d6o7">
                <button type="button" onClick={() => toggleShopping(i.id)} aria-pressed={i.done} aria-label={`${i.text}: ${i.done ? 'odznači' : 'kupljeno'}`} className={`grid h-7 w-7 shrink-0 place-items-center rounded-lg border-2 ${i.done ? 'border-done bg-done text-white' : 'border-[#C9BBA4] text-transparent hover:border-done'}`} data-id="element-253" data-mp="j8rdo5d80v9k">
                  <CheckIcon className="h-4 w-4" strokeWidth={3.5} aria-hidden="true" data-id="element-254" data-mp="4mlnivujzy5l" />
                </button>
                <span className={`min-w-0 flex-1 font-semibold ${i.done ? 'text-muted line-through' : ''}`} data-id="element-255" data-mp="3mt8dyll19ben">{i.text}</span>
                <span className="text-xs text-muted" data-id="element-256" data-mp="3qutx2oo5ulxa">{memberById(i.addedBy)?.name}</span>
              </li>)}
          </ul>}
        {bought > 0 && <Button size="sm" variant="ghost" className="mt-2" onClick={clearBought} data-id="element-257" data-mp="nbscv1puro0d">
            Počisti kupljeno ({bought})
          </Button>}
      </div>
      <aside className="rounded-3xl bg-canvas p-4 text-sm" data-id="element-258" data-mp="dlp7s35gijlo">
        <p className="font-bold" data-id="element-259" data-mp="dk4c2a7eoum8">Organizacija brez novega modula</p>
        <p className="mt-1 text-muted" data-id="element-260" data-mp="11ai80bt43dm3">Torba za jutri, pospravljanje za seboj, prevozi, nakupi, obroki in administracija so predloge nalog (Nastavitve › Naloge) ali koledarski dogodki.</p>
        <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-261" data-mp="2qrvwlpyi1bwa">
          {quickTaskPresets.map(p => <li key={p} className="rounded-full bg-surface px-2.5 py-1 text-xs font-bold" data-id="element-262" data-mp="2lt2efk89owps">
              {p}
            </li>)}
        </ul>
      </aside>
    </div>;
}